import { makeStyles, Theme } from '@material-ui/core/styles';
import { blue } from '@material-ui/core/colors';
export const useStyles = makeStyles((theme: Theme) => ({
  topbar: {
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '2px 32px',
    backgroundColor: '#F6F6F6',
  },
  closeIcon: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
  },
  input: {
    minWidth: 250,
    flexGrow: 1,
    fontSize: 16,
    color: 'rgb(0 0 0 / 87%)',
    '& .MuiInputBase-input.Mui-disabled': {
      color: 'rgb(0 0 0 / 87%)',
    },
  },
  label: {
    //margin: '0 0 24px',
    margin: theme.spacing(1),
    fontSize: 20,
    color: 'black',
    fontWeight: 500,
    lineHeight: '27px',
  },
  closebtn: {
    color: '#000000DE',
  },
  tablabel: {
    minWidth: 'auto',
    maxWidth: 'inherit',
    padding: 0,
    fontWeight: 500,
    fontSize: 16,
    textTransform: 'uppercase',
  },
  tabsPanel: {
    width: '100%',
  },
  tabsPaper: {
    width: '100%',
    boxShadow: theme.shadows[0],
    backgroundColor: 'transparent',
    '& [class*="MuiBox-root"]': {
      // padding: theme.spacing(2, 0, 0, 0),
    },
  },
  tabs: {
    // width: 'fit-content',
    border: '1px solid white',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },

    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '14px 22px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  tabs2: {
    // width: 'fit-content',
    border: '1px solid white',
    paddingTop: '24px',
    borderRadius: '4px 0px 0px 4px',
    background: 'white',
    '& .MuiTabs-indicator': {
      backgroundColor: 'orange',
      height: 3,
    },
    '& .MuiTab-root.Mui-selected': {
      color: 'white',
      backgroundColor: '#5081FF',
    },
    '& .MuiTab-root': {
      padding: '16px 24px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  tabBox: {
    margin: '0 20px',
    '& > div > div': {
      padding: 0,
    },
  },
  modal: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  title: {
    width: 170,
    // marginLeft: theme.spacing(2),
    color: 'rgb(0 0 0 / 70%)',
  },
  paper: {
    width: '900px',
    height: 'auto',
  },

  block: {
    margin: '0 20px',
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    padding: '0 24px 24px 24px',
  },
  btnrow: {
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom: theme.spacing(2),
    flexBasis: '45%',
    flexWrap: 'wrap',
    '@media (max-width: 1399px)': {
      flexBasis: '100%',
    },
  },
  btn1: {
    marginTop: theme.spacing(1),
    marginRight: '12px',
    padding: '12px 0',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  btn2: {
    marginTop: theme.spacing(1),
    marginLeft: '12px',
    padding: '12px 0',
    '& .MuiButton-label': {
      textTransform: 'none',
    },
  },
  textField: {
    width: '100%',
    marginRight: theme.spacing(2),
    //borderBottom: '1px solid #E0E0E0',
    //padding: 5,
    color: 'rgb(0 0 0 / 87%)',
  },
  textFileField: {
    marginRight: theme.spacing(2),
    fontSize: '16px',
    padding: '2px',
    background: '#eeeeee',
    border: '1px solid black',
    color: 'rgb(0 0 0 / 87%)',
    cursor: 'pointer',
  },
  center: {
    display: 'block',
    margin: 'auto',
  },
  row: {
    padding: '24px',
  },
  rowf: {
    padding: '0px 24px',
  },
  keywordTitle: {
    margin: theme.spacing(6, 3, 0, 0),
  },
  keywords: {
    marginLeft: theme.spacing(3),
    color: blue[700],
  },
  space: {
    marginLeft: theme.spacing(1),
    cursor: 'pointer',
    color: 'red',
  },
  inputWrapper: {
    height: '32px',
    width: '64px',
    overflow: 'hidden',
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: '#DDF',
  },
  fileInput: {
    cursor: 'pointer',
    height: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    zIndex: 99,
    fontSize: '50px',
    opacity: '0',
  },
  margin: {
    margin: '0',
  },
  formContainer: {
    flex: 1,
  },
}));
